"use client"
import { WorkflowHub } from "@/components/workflow-hub"
import { WorkflowProvider } from "@/context/workflow-context-simple"
import { LanguageProvider } from "@/context/language-context"

export default function Home() {
  return (
    <div className="h-screen overflow-hidden">
      <LanguageProvider>
        <WorkflowProvider>
          <WorkflowHub />
        </WorkflowProvider>
      </LanguageProvider>
    </div>
  )
}
